import { createSelector } from "reselect";

const patients = ({ patients }) => patients;
const patientsUI = ({ patients }) => patients.patientsUI;

export const selectPatients = createSelector(
  [patients],
  (patients) => patients
);

export const selectPatientsUI = createSelector(
  [patientsUI],
  (patientsUI) => patientsUI
);
